export const createEngine = function (canvas: HTMLCanvasElement, scaleFactor: number) {

    let _scaleFactor: number = scaleFactor;
    let engine = new BABYLON.Engine(canvas, true);
    window.addEventListener("resize", function (e) {
        if (engine) {
            engine.resize();
        }
    });
    window.addEventListener("orientationchange", function (e) {
        if (engine) {
            engine.resize();
        }
    });

    return engine;
}

export const createEnvironment = function (scene: BABYLON.Scene) {
    var hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("/static/environment/studio.env", scene, null, true);
    hdrTexture.level = 1;  
    scene.environmentTexture = hdrTexture;

    scene.imageProcessingConfiguration.toneMappingEnabled = true;
    scene.imageProcessingConfiguration.toneMappingType = BABYLON.ImageProcessingConfiguration.TONEMAPPING_ACES;
    scene.imageProcessingConfiguration.exposure = 1.2;
    scene.imageProcessingConfiguration.contrast = 1.2;
}

export const createScene = function (engine: BABYLON.Engine) {

    let scene = new BABYLON.Scene(engine); 
    scene.imageProcessingConfiguration.contrast = 1.8;
    scene.imageProcessingConfiguration.exposure = 1.0;
    scene.imageProcessingConfiguration.toneMappingEnabled = true;
    scene.clearColor = BABYLON.Color4.FromHexString("#FFFFFF");
    return scene;
}

export const createLight = function (name: string, scene: BABYLON.Scene, position: BABYLON.Vector3, direction: BABYLON.Vector3, intensity: number, shadowMinZ: number, shadowMaxZ: number) {

    let light = new BABYLON.DirectionalLight(name, direction, scene);
    light.intensity = intensity;
   // light.autoCalcShadowZBounds = true;
    light.shadowEnabled = true;   
    light.position = position;
    light.shadowMinZ = shadowMinZ;
    light.shadowMaxZ = shadowMaxZ;

    return light;
}

export const createRenderTargetCamera = function (name: string, scene: BABYLON.Scene) {

    let renderTargetCamera = createCamera(name,scene);
    return renderTargetCamera;

}

export const createMainCamera = function (scene: BABYLON.Scene) {

    let mainCamera = createCamera("main", scene);  
    return mainCamera;

}

export const createCamera = function (name: string, scene: BABYLON.Scene) {

    let camera = new BABYLON.ArcRotateCamera(
        name,
        Math.PI / 2,
        Math.PI / 2.5,
        12,
        new BABYLON.Vector3(0, 0, 0),
        scene
    );

    camera.angularSensibilityX = 1000;
    camera.angularSensibilityY = 1000;   
    camera.panningSensibility = 1000;
    camera.panningInertia = 0;
    camera.panningAxis = new BABYLON.Vector3(1, 0, 1);
    camera.inertia = 0;
    camera.useNaturalPinchZoom = true;
    camera.wheelDeltaPercentage = 0.05;
    camera.fov = 0.6;  
    camera.upperBetaLimit = Math.PI / 2;
    camera.lowerBetaLimit = 0;
    camera.lowerRadiusLimit = 1;
    camera.upperRadiusLimit = 15;
    camera.fovMode = BABYLON.Camera.FOVMODE_HORIZONTAL_FIXED;
    camera.minZ = 1;
    camera.maxZ = 1000;

    return camera;

}

export const CreateScreenshotUsingRenderTargetAsync = async function(engine, camera, size, mimeType, samples, antialiasing, successCallback, fileName, renderSprites, enableStencilBuffer, useLayerMask, quality): Promise<string> {
    const { height, width } = { width: size.width, height: size.height };
    let targetTextureSize = { width, height };

    if (!(height && width)) {
        BABYLON.Logger.Error("Invalid 'size' parameter");
        return;
    }

    var save = engine.getAspectRatio;

    var scene = camera.getScene();
    var previousCamera = null;
    var previousCameras = scene.activeCameras;

    scene.activeCameras = null;

    if (scene.activeCamera !== camera) {
        previousCamera = scene.activeCamera;
        scene.activeCamera = camera;
    }

    engine.getAspectRatio = () => {
        return width / height;
    };

    scene.render(); // make sure the scene is ready to be rendered in the RTT with the right list of active meshes (which depends on the camera, that may have been changed above)

    // At this point size can be a number, or an object (according to engine.prototype.createRenderTargetTexture method)
    var texture = new BABYLON.RenderTargetTexture("screenShot", targetTextureSize, scene, false, false, BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, false, BABYLON.Texture.NEAREST_SAMPLINGMODE, undefined, enableStencilBuffer, undefined, undefined, undefined, samples);
    texture.renderList = null;
    texture.samples = samples;
    texture.renderSprites = renderSprites;

    const renderToTexture = () => {

        engine.onEndFrameObservable.addOnce(() => {         
            const prom = texture.readPixels(undefined, undefined, undefined, false)
            prom.then((data) => {              
                successCallback(BABYLON.Tools.DumpDataAsync(width, height, data, mimeType, fileName, true, false, quality));
                texture.dispose();
            });
        });

        scene.render();

        // render the RTT
        scene.incrementRenderId();
        scene.resetCachedMaterial();
        texture.render(true);

        // re-render the scene after the camera has been reset to the original camera to avoid a flicker that could occur
        // if the camera used for the RTT rendering stays in effect for the next frame (and if that camera was different from the original camera)
        scene.incrementRenderId();
        scene.resetCachedMaterial();
        if (previousCamera) {
            scene.activeCamera = previousCamera;
        }
        scene.activeCameras = previousCameras;
        engine.getAspectRatio = save;
        camera.getProjectionMatrix(true); // Force cache refresh;
        scene.render();
    };

    if (antialiasing) {
        const fxaaPostProcess = new BABYLON.FxaaPostProcess('antialiasing', 1.0, scene.activeCamera);
        texture.addPostProcess(fxaaPostProcess);
        // Async Shader Compilation can lead to none ready effects in synchronous code
        if (!fxaaPostProcess.getEffect().isReady()) {
            fxaaPostProcess.getEffect().onCompiled = () => {
                renderToTexture();
            };
        }
        // The effect is ready we can render
        else {
            renderToTexture();
        }
    }
    else {
        // No need to wait for extra resources to be ready
        renderToTexture();
    }
}

export const createGround = function (light: BABYLON.ShadowLight, scene: BABYLON.Scene) {

    var ground = BABYLON.MeshBuilder.CreateGround("ground", { width: 1000, height: 1000 }, scene);
  
    ground.material = new BABYLON.ShadowOnlyMaterial('shadowOnly', scene);
    (ground.material as BABYLON.ShadowOnlyMaterial).activeLight = light;
    ground.material.alpha = 0.15;
    ground.receiveShadows = true;
    ground.isPickable = false;

    return ground;
}

export const createShadowgenerator = function (light: BABYLON.ShadowLight, darkness: number, penumbra: number) {

    var shadowGenerator = new BABYLON.ShadowGenerator(1024, light);
    shadowGenerator.setDarkness(darkness);   
    //shadowGenerator.usePoissonSampling = true;
    //shadowGenerator.useContactHardeningShadow = true;
    //shadowGenerator.contactHardeningLightSizeUVRatio = penumbra;    
    shadowGenerator.usePercentageCloserFiltering = true;
    shadowGenerator.filteringQuality = BABYLON.ShadowGenerator.QUALITY_MEDIUM;    
    shadowGenerator.bias = 0.01;
    shadowGenerator.normalBias = 0;

    return shadowGenerator;
}